import React from 'react'
import { Trans, useLingui } from '@lingui/react/macro'

import { YStack, XStack, isWeb, useThemeName, useMedia } from 'tamagui'

import { Paragraph } from './Text'
import { Link, ExternalLink } from './Link'
import { Icon } from './Icon'
import { IconWrapper } from '@newComponents/Icon/IconWrapper'
import { usePalette } from './Palette/PaletteContext'

import BlueskyIcon from '@newComponents/Icon/icons/BlueskyIcon'

export const Footer = () => {
  const { t } = useLingui()
  const { palette } = usePalette()
  const themeName = useThemeName()
  const isDark = themeName.startsWith('dark')
  const { reducedMotion: reducedEffects } = useMedia()
  const useGlass = !!palette && isWeb

  const glassStyle = useGlass
    ? {
        backgroundColor: isDark
          ? 'rgba(0, 0, 0, 0.35)'
          : 'rgba(255, 255, 255, 0.45)',
        ...(reducedEffects
          ? {}
          : {
              backdropFilter: 'blur(16px)',
              WebkitBackdropFilter: 'blur(16px)',
            }),
      }
    : undefined

  return (
    <YStack
      backgroundColor={useGlass ? 'transparent' : '$backgroundStrong'}
      paddingVertical='$4'
      paddingHorizontal='$5'
      width='100%'
      marginLeft='auto'
      marginRight='auto'
      $gtXs={{
        borderRadius: '$5',
        width: 392,
        marginBottom: 46,
      }}
      data-nosnippet
      style={glassStyle}
    >
      <XStack justifyContent='space-between'>
        <YStack justifyContent='space-between'>
          <XStack gap='$3'>
            <Paragraph size='$4' fontWeight='$7' color='$colorMuted'>
              Guild
            </Paragraph>

            <Link href='/docs' size='$4' color='$colorMuted' fontWeight='$4'>
              <Trans>Docs</Trans>
            </Link>
            <Link
              href='/legal/terms'
              size='$4'
              color='$colorMuted'
              fontWeight='$4'
            >
              <Trans>Terms</Trans>
            </Link>
            <Link
              href='/legal/privacy'
              size='$4'
              color='$colorMuted'
              fontWeight='$4'
            >
              <Trans>Privacy</Trans>
            </Link>
          </XStack>

          <XStack alignItems='center' gap='$2'>
            <ExternalLink
              href='https://bsky.app/profile/guild.host'
              lineHeight='$3'
              aria-label={t`Link to Guild's Bluesky`}
            >
              <IconWrapper size='$4' color='$colorSubtle'>
                <BlueskyIcon />
              </IconWrapper>
            </ExternalLink>

            <ExternalLink
              href='https://twitter.com/guild__host'
              lineHeight='$3'
              aria-label={t`Link to Guild's Twitter`}
            >
              <Icon name='twitter' size='$4' color='$colorSubtle' />
            </ExternalLink>

            <ExternalLink
              href='https://www.youtube.com/@guild_host'
              lineHeight='$3'
              aria-label={t`Link to Guild's YouTube`}
            >
              <Icon name='youtube' size='$4' color='$colorSubtle' />
            </ExternalLink>

            <ExternalLink
              href='https://www.linkedin.com/company/guild-host'
              lineHeight='$3'
              aria-label={t`Link to Guild's LinkedIn`}
            >
              <Icon name='linkedin' size='$4' color='$colorSubtle' />
            </ExternalLink>
          </XStack>
        </YStack>

        <YStack justifyContent='space-between' alignItems='flex-end'>
          <Paragraph
            fontWeight='$5'
            color='$colorMuted'
            size='$4'
            textAlign='right'
          >
            <Trans>Get in touch!</Trans>
          </Paragraph>

          <span className='notranslate'>
            <ExternalLink
              href='mailto:hi@guild.host'
              size='$4'
              color='$colorMuted'
            >
              hi@guild.host
            </ExternalLink>
          </span>
        </YStack>
      </XStack>
    </YStack>
  )
}
